module.exports = __webpack_public_path__ + "static/img/huodong.00f55540.png";